export default __webpack_public_path__ + "static/media/organization.1778b6fb.png";